import React, {Component} from 'react';
import ReceiptBasket from './ReceiptBasket';

class ReceiptList extends Component {
    render() {
        const { receipt } = this.props;
        return (
            <div>
                {
                    <ReceiptBasket
                        key={ receipt.id }
                        price={ receipt.basket.price }
                        items={ receipt.basket.transaction_items }
                        currency={ receipt.basket.currency }
                    />
                }
            </div>
        )
    }
}
export default ReceiptList;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/ReceiptList.js